module.exports = {
  // domain: "http://localhost:8581",
  domain: "https://api.ayabrackett.com",

  categories: [
    "Books",
    "Still Life",
    "Portraits",
    "Travel",
    "Magazines",
    "Advertising",
  ],
};
